import React from "react";
import SetNewPassword from '../../views/login/setNewPassword'

export default function Login() {
    return <SetNewPassword />
}